import { UserService } from './../../../shared/services/user.service';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { OnboardingNavComponent } from '../onboarding-nav/onboarding-nav.component';

@Component({
  selector: 'qwiko-onboarding-shell',
  imports: [CommonModule, RouterModule, OnboardingNavComponent],
  templateUrl: './onboarding-shell.component.html',
  styleUrl: './onboarding-shell.component.scss',
})
export class OnboardingShellComponent {
  private userService = inject(UserService);
  private router = inject(Router);

  constructor() {
    // console.log('Checked');
    // if (this.userService.user()?.has_org) {
    //   this.router.navigateByUrl('/home');
    // }
  }
}
